import { ContainerModule, interfaces } from "inversify";
import DataGridService from "../../../features/shared/components/dataGrid/DataGridService";
import IDataGridService from "../../../features/shared/components/dataGrid/IDataGridService";
import { IocTypes } from "../ioc.types";

export const datagridModule = new ContainerModule((bind: interfaces.Bind) => {
    bind<IDataGridService>(IocTypes.DataGridService).to(DataGridService);            
});